// Validate the zone to be valid
const getArea = (zone) => {
  if (!zone || (!zone.meta && !zone.area)) {
    // We want the lowest number in case of being invalid
    return null;
  } else if (zone.meta) {
    // Check if it has a meta property and use it
    return zone.meta.area.q;
  }
  // Otherwise use area
  return zone.area.q;
};

export const asciibeticalCompare = (a, b) => {
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  return 0;
};

export const sortByArea = (a, b) => {
  // Calculate the difference
  const difference = getArea(a) - getArea(b);

  // Be sure to make it -1 | 0 | 1 so it can be easily tested
  if (difference > 0) {
    return 1;
  } else if (difference < 0) {
    return -1;
  }
  return 0;
};

export const zoneIdSortedByMedian = (zones) => {
  return Object.keys(zones).map((zone) => {
    return {'zoneId': zone, 'median': zones[zone].geoJson.properties.median};
  }).sort((a,b) => {
    return a.median - b.median;
  }).map((zone) => {
    return zone.zoneId;
  });
};

export const sortByBiomass = (zoneA, zoneB) => zoneA?.geoJson?.properties?.median - zoneB?.geoJson?.properties?.median;

/**
 * Compares two zones by their relative productivity, so that they can be sorted in descending order.
 * Zones without productivity are always consider lesser than zones with productivity.
 * @import {GeneratedZone} from "../store/types/types.ts"
 * @param {GeneratedZone} zoneA - A generated zone object
 * @param {GeneratedZone} zoneB - A generated zone object
 *
 * @returns {number} - 0 if both zones have equal productivity, or neither
 * has productivity,
 * - -1 if zoneA has greater productivity, or zoneB has no productivity,
 * - 1 if zoneB has greater productivity, or zoneA has no productivity.
 */
export const sortByRelativeProductivity = (zoneA, zoneB) => {
  const productivityA = zoneA.geoJson.properties?.relativeProductivity?.v;
  const productivityB = zoneB.geoJson.properties?.relativeProductivity?.v;
  const zoneAHasNoProductivity = !productivityA && productivityA !== 0;
  const zoneBHasNoProductivity = !productivityB && productivityB !== 0;

  if (productivityA === productivityB || (zoneAHasNoProductivity && zoneBHasNoProductivity)) {
    return 0;
  } else if (productivityA > productivityB || (zoneBHasNoProductivity)) {
    return -1;
  } else {
    return 1;
  }
};

export const getZonesSortingCriteria = (canSortZonesByProperties, isMultiLayerEnabled) => {
  if (canSortZonesByProperties) {
    if (isMultiLayerEnabled) {
      return sortByRelativeProductivity;
    }
    return sortByBiomass;
  }
  return sortByArea;
};
